import {
  TABLE_ROW_SINGLE_LINE,
  TABLE_ROW_TRIPLE_LINE,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";

export class FeePortfolioDetailsConfigs {
  static readonly LimitOfCharsInOneLine = 100;

  static readonly DefaultRowHeight = TABLE_ROW_SINGLE_LINE;
  static readonly IncreasedRowHeight = TABLE_ROW_TRIPLE_LINE;

  static readonly SectionGap = 30;
}
